"use client"

import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { connect } from "react-redux"
import { motion } from "framer-motion"

import { ChevronRight, CircleArrowDown } from "lucide-react"
import useOrientation from "@/hooks/useOrientation"
import Topnav from "@/components/topnav"
import TextRegularM from "@/components/text/text-regular-m"
import TitleL from "@/components/text/title-l"
import PlayButton from "@/components/buttons/PlayButton"
import PlaylistCardB from "@/app/pages/homePage/components/albumes/cardAlbum/card-album"

import PlaylistDetails from "./components/album-details"
import PlaylistTrack from "./components/album-track"
import PlaylistFooter from "./components/album-footer"

import { calcularDuracionPlaylist } from "@/core/utils/utils"
import { PLAYLIST, ALBUM } from "@/data"
import { changeTrack } from "@/core/actions"

import type { AlbumData } from "./types"

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
}

/* function isAlbum(item: any): item is AlbumData {
  return item?.type === "album" && Array.isArray(item?.playlistData)
} */

function AlbumPage(props: any) {
  const { isPortrait, isLandscape, isStandalone, isDesktopStandalone } = useOrientation()
  const { link } = useParams()

  const [album, setAlbum] = useState<AlbumData | null>(null)
  const [isThisPlay, setIsThisPlay] = useState(false)

  /* =========================
     FIND ALBUM
  ========================= */
  
  useEffect(() => {
    const realAlbum = ALBUM.find(
      item => item.link === link
    ) as AlbumData | undefined

    if (!realAlbum) return

    setAlbum(realAlbum)

    document.documentElement.style.setProperty(
      "--hover-home-bg",
      realAlbum.playlistBg
    )
  }, [link])

  /* =========================
     PLAY STATE
  ========================= */
  useEffect(() => {
    if (!album) return

    setIsThisPlay(
      String(props.trackData?.trackKey?.[0]) === String(album.id)
    )
  }, [album, props.trackData])

  /* =========================
     SHUFFLE
  ========================= */
  function shuffleArray<T>(array: T[]): T[] {
    return [...array].sort(() => Math.random() - 0.5)
  }

  const shuffledAlbums = shuffleArray(
  ALBUM
    .filter(item => item.link !== link)
    .slice(0, 10)
)

  /* =========================
     CLICK SONG
  ========================= */
  const handleSongClick = (item: AlbumData, song: any) => {
  const songIndex = item.playlistData.findIndex(
    s => s.id === song.id
  )

  if (songIndex === -1) {
    console.error("Canción no encontrada")
    return
  }

  props.changeTrack([
    item.id,
    songIndex,
  ])
}

  /* =========================
     LOADING
  ========================= */
  if (!album) return null

  const duracionTotal = calcularDuracionPlaylist(album.playlistData)

  return (
    <div className="
            relative w-full h-[100dvh]
            overflow-hidden overscroll-none
            touch-pan-y">
              
      <Topnav />

      {/* <div className="relative w-full h-full overflow-y-auto text-white pb-6"> */}
      <div
  className={`
    inset-0
    flex flex-col
    overflow-hidden
    w-full
    no-scrollbar
    select-none
    overscroll-contain
    ${isLandscape ? "h-[calc(100%-3.7rem)] border border-white/15 rounded-xl" : ""}
    ${isPortrait ? "h-[100dvh] pb-0 mb-0" : ""}
    ${isStandalone ? "h-[100dvh] mb-40" : ""}
  `}
>
  <div> {/* className={`
          relative
          w-full
          h-full
          overflow-scroll
          text-white
          rounded-2xl
          no-scrollbar
          ${isLandscape ? "pb-0" : ""}
          ${isPortrait ? "pb-0" : ""}
          ${isStandalone ? "pb-40" : "pb-0"}
          ${isDesktopStandalone ? "pb-0" : ""}
        `} */}

  </div>
        <div
          className="absolute inset-0 -z-10 bg-black"
          style={{ background: album.playlistBg }}
        />

        <motion.div
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <PlaylistDetails
            data={album}
            duracionTotal={duracionTotal}
          />

          <div className="flex px-6 py-4 justify-center">
            <div
              className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center"
              onClick={() =>
                handleSongClick(album, album.playlistData[0])
              }
            >
              <PlayButton />
            </div>
          </div>

          <div className="grid gap-1 grid-cols-[2rem_1fr_2.8rem_3rem] items-center px-4 mb-2 text-zinc-400">
            <TextRegularM className="text-center text-[.65rem] pl-4">#</TextRegularM>
            <TextRegularM className="text-left text-[.65rem] pl-1">Título</TextRegularM>
            <TextRegularM> <CircleArrowDown size={15}/> </TextRegularM>
            <TextRegularM className="text-center text-[.65rem] ">Time</TextRegularM>
          </div>

          {/* <div className="grid grid-cols-[2rem_1fr_2rem_3rem] px-4 text-gray-400 text-sm">
            <TextRegularM className="text-center">#</TextRegularM>
            <TextRegularM>Título</TextRegularM>
            <TextRegularM>↓</TextRegularM>
            <TextRegularM>⏱</TextRegularM>
          </div> */}

          <div className="grid gap-2 px-4 pb-8">
                      {album.playlistData.map((song: any) => (
                        <div
                          key={song.id}
                          onClick={() =>
                            handleSongClick(album, song)
                          }
                          className="block w-full rounded-xl bg-white/[0.05] shadow-[inset_0_0_0_1px_rgba(255,255,255,.1)]"
                        >
                          <PlaylistTrack
                            data={{
                              listType: album.type,
                              song,
                            }}
                          />
                        </div>
                      ))}
                    </div>


          {/* <div className="px-2 flex flex-col gap-2">
            {album.playlistData.map((song) => (
              <div
                key={song.id}
                onClick={() => handleSongClick(album, song)}
                className="rounded-xl bg-white/5 border border-white/10"
              >
                <PlaylistTrack
                  data={{ listType: "album", song }}
                />
              </div>
            ))}
          </div> */}

          <section className="mt-6 pb-30">
            <div className="px-4 mb-3">
              <TitleL>Álbumes Similares</TitleL>
            </div>

            <div className="flex gap-4 overflow-x-auto px-4
            relative w-full overflow-hidden overscroll-none touch-pan-y">
              {shuffledAlbums.map((item, i) => (
                <div key={item.title} className="min-w-[180px]">
                  <PlaylistCardB data={item} />
                </div>
              ))}
            </div>
          </section>

          <PlaylistFooter data={album} />
        </motion.div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => ({
  trackData: state.trackData,
})

export default connect(mapStateToProps, {
  changeTrack,
})(AlbumPage)